module.exports = __webpack_public_path__ + "static/media/insurance_item-02.cf801521.svg";